import React from 'react';
import { Link } from 'react-router-dom';

const cognitionTests = [
    {
        name: 'Typing Speed',
        description: 'Test your typing speed and accuracy',
        path: '/cognition-lab/typing-speed',
        icon: (
            <svg viewBox="0 0 48 48" fill="none" className="h-10 w-10" aria-hidden="true">
                <rect x="4" y="12" width="40" height="24" rx="4" fill="#FDE68A" stroke="#825812" strokeWidth="2" />
                <rect x="10" y="18" width="28" height="4" rx="2" fill="#825812" />
                <rect x="10" y="26" width="8" height="4" rx="2" fill="#825812" />
                <rect x="20" y="26" width="8" height="4" rx="2" fill="#825812" />
                <rect x="30" y="26" width="8" height="4" rx="2" fill="#825812" />
            </svg>
        )
    },
    {
        name: 'Speed Reading',
        description: 'Measure your reading speed',
        path: '/cognition-lab/speed-reading',
        icon: (
            <svg viewBox="0 0 48 48" fill="none" className="h-10 w-10" aria-hidden="true">
                <rect x="6" y="12" width="36" height="24" rx="4" fill="#FDE68A" stroke="#825812" strokeWidth="2" />
                <path d="M12 20h24M12 28h24" stroke="#825812" strokeWidth="3" strokeLinecap="round" />
                <circle cx="24" cy="24" r="3" fill="#825812" />
            </svg>
        )
    },
    {
        name: 'Memory Recall',
        description: 'Challenge your memory skills',
        path: '/cognition-lab/memory-recall',
        icon: (
            <svg viewBox="0 0 48 48" fill="none" className="h-10 w-10" aria-hidden="true">
                <rect x="8" y="12" width="32" height="24" rx="8" fill="#FDE68A" stroke="#825812" strokeWidth="2" />
                <circle cx="24" cy="24" r="6" fill="#825812" />
                <rect x="20" y="30" width="8" height="4" rx="2" fill="#825812" />
            </svg>
        )
    }
];

function CognitionLab() {
    
    return (
        <div className="bg-white rounded-lg shadow p-6 space-y-4">
            <h2 className="text-xl sm:text-2xl font-bold text-iof mb-4 sm:mb-6">Cognition Lab</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {cognitionTests.map((test) => (
                    <Link
                        key={test.path}
                        to={test.path}
                        className="bg-gray-50 rounded-lg p-4 flex items-center space-x-4 hover:bg-gray-100 transition border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[rgb(130,88,18)]"
                    >
                        <div className="flex-shrink-0">{test.icon}</div>
                        <div className="flex-1">
                            <h3 className="text-base font-semibold text-gray-800">{test.name}</h3>
                            <p className="text-sm text-gray-600">{test.description}</p>
                        </div>
                        <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                        </svg>
                    </Link>
                ))}
            </div>
            <div className="flex justify-center mt-4">
                <Link
                    to="/cognition-lab"
                    className="inline-flex items-center px-4 py-2 bg-[rgb(130,88,18)] text-white rounded-full hover:bg-[rgb(110,68,0)] transition focus:outline-none focus:ring-2 focus:ring-[rgb(130,88,18)]"
                >
                    <span>View All Tests</span>
                    <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                    </svg>
                </Link>
            </div>
        </div>
    );
}

export default CognitionLab;